// extracted by mini-css-extract-plugin
export default {"recipientCircle":"RecipientSelect_recipientCircle__U-n2R"};